export default __webpack_public_path__ + "static/media/lr_short_logo.73774f4d.svg";